/* eslint-disable no-unused-vars */
export enum BillingResponsibility {
  PATIENT = 'PATIENT',
  FACILITY = 'FACILITY',
}
